import { Trans } from '@lingui/react/macro';
import { Box, Button, H1, Typography } from '@pocketlaw/tetris';
import { showReportDialog } from '@sentry/browser';
import DeriveTitle from './DeriveTitle';
import illustration from './illustration.svg';
import { Container, Image, Line } from './styled';
export function AppError(props) {
    const { id, code = 500, message, title, action } = props;
    return (<Container data-testid="app-error">
      <div>
        <Box flexDirection="column" mb="lg">
          {code && (<Typography $lineHeight="neutralized" $fontWeight="semibold" $appearance="100" $fontSize="large">
              {code}
            </Typography>)}
          <H1>{title || <DeriveTitle code={code}/>}</H1>
          <Line />
          <Typography $lineHeight="neutralized">
            {message || (<Trans>We have been notified and are working on fixing the issue. Please try to reload the page.</Trans>)}
          </Typography>
        </Box>

        <Box gap="md">
          {id && (<Button type="button" size="small" appearance="secondary" onClick={() => showReportDialog({ eventId: id })}>
              <Trans>Report error feedback</Trans>
            </Button>)}
          {action || (<Button as="a" href="/" size="small">
              <Trans>Take me back</Trans>
            </Button>)}
        </Box>
      </div>

      <Image src={illustration} alt="Not Found"/>
    </Container>);
}
